/* eslint-disable */
// @TODO - remover o erro de identação na linha 127 e o eslint disable

'use client';

// import Choices from 'choices.js';
import { useTranslationStore } from '@/stores';
import { SelectHTMLAttributes, useEffect } from 'react';
import { useTranslation as t } from '../../hooks/useTranslation';
import {
  IEpSelectOptionsListData,
  IEpSelectOptionsListDataFormatted,
  IEpSelectTranslations,
} from '../../interfaces';
import './EpSelect.scss';

import Choices from 'choices.js';

interface IEpStepSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  selectId: string;
  selectName: string;
  selectSize: 'sm' | 'md' | 'lg';
  selectType: 'single' | 'multiple';
  selectAriaLabel?: string;
  selectIsFullWidth?: boolean; // = true
  selectWidth?: number; // = 300
  // selectMaxSelectableItems?: number // = -1 //TODO: Implementar a funcionalidade de quantidade de options máximas selecionáveis
  selectPlaceholderText?: string; // = ''
  selectWithClearFieldButton?: boolean; // = true
  selectLeftIconName?: string;
  selectRightIconName?: string;
  selectWithError?: boolean; // = false
  selectIsDisabled?: boolean; // = false
  optionsSearchKeys?: string[];
  optionsData: IEpSelectOptionsListData[];
  itemSelected?: string;
  minCharactersToSearch?: number;
  customLabelValue?: [string, string];
  onChange?: any; // (args?: unknown) => void
  messages?: {
    addOptionText?: string;
    loadingText?: string;
    noResultsText?: string;
    noChoicesText?: string;
    maxOptionsText?: string;
  };
  customClasses?: string;
  translations?: IEpSelectTranslations;
}

export const EpSelect = (props: IEpStepSelectProps) => {
  const {
    selectId,
    selectName,
    selectSize,
    // selectType,
    selectAriaLabel,
    selectIsFullWidth = true,
    selectWidth = 300,
    // selectPlaceholderText,
    selectWithClearFieldButton = true,
    selectLeftIconName,
    // selectRightIconName,
    selectWithError,
    selectIsDisabled,
    optionsSearchKeys,
    minCharactersToSearch,
    optionsData,
    itemSelected,
    messages,
    onChange,
    customLabelValue,
    customClasses,
    // translations
  } = props;

  const { translations } = useTranslationStore();

  const optionsDataFormatted: IEpSelectOptionsListDataFormatted[] =
    optionsData?.map((option: any) => {
      return {
        ...option,
        label: option.label || ``,
        value: option.value || ``,
        ...(customLabelValue &&
          customLabelValue[0] && { label: `${option[customLabelValue[0]]}` }),
        ...(customLabelValue &&
          customLabelValue[1] && { value: `${option[customLabelValue[1]]}` }),
      };
    });

  if (optionsDataFormatted?.length === 1) {
    optionsDataFormatted[0].selected = true;
  }

  if (itemSelected && optionsDataFormatted) {
    optionsDataFormatted.map((option: IEpSelectOptionsListDataFormatted) => {
      if (option.value.toString() === itemSelected) {
        option.selected = true;
      }
      return option;
    });
  }

  useEffect(() => {
    const selectElement = document.querySelector(
      `select[selectid='${selectId}']`,
    ) as HTMLSelectElement;

    const selectInstance = new Choices(selectElement, {
      allowHTML: true,
      searchPlaceholderValue: '',
      itemSelectText: '',
      searchFields: optionsSearchKeys || ['mainContentLabel', 'label'],
      searchFloor: minCharactersToSearch || 1,
      searchResultLimit: optionsDataFormatted.length || 10,
      resetScrollPosition: false,
      removeItems: selectWithClearFieldButton,
      removeItemButton: selectWithClearFieldButton,
      shouldSort: false,
      ...(optionsDataFormatted && {
        choices: [
          {
            value: '',
            label: t(translations['global'], 'Select'),
            selected: optionsDataFormatted.length === 1 ? false : true,
            disabled: true,
          },
          ...optionsDataFormatted,
        ],
      }),
      ...(messages?.addOptionText && {
        itemSelectText: messages?.addOptionText,
      }),
      ...(messages?.loadingText && { loadingText: messages?.loadingText }),
      ...(messages?.noResultsText && {
        noResultsText: messages?.noResultsText,
      }),
      ...(messages?.noChoicesText && {
        noChoicesText: messages?.noChoicesText,
      }),
      ...(messages?.maxOptionsText && {
        maxItemText: messages?.maxOptionsText,
      }),
      noResultsText: t(translations['global'], 'No results found'),

      fuseOptions: {
        threshold: 0,
      },
    });
  }, [
    selectId,
    optionsSearchKeys,
    minCharactersToSearch,
    selectWithClearFieldButton,
    messages,
    optionsDataFormatted,
  ]);

  return (
    <div
      data-select-id={selectId}
      className={`ep-select ep-select--${selectSize}
      ${selectWithError ? 'ep-select--with-error' : ''}
      ${selectIsDisabled || optionsDataFormatted.length === 1
          ? 'ep-select--is-disabled'
          : ''
        }
      ${!selectLeftIconName ? 'ep-select--without-left-icon' : ''}
      ${customClasses ? customClasses : ''}`}
      {...(!selectIsFullWidth && { style: { width: `${selectWidth}px` } })}
    >
      <select
        id={selectId}
        name={selectName}
        className="form-select form-control"
        aria-label={selectAriaLabel}
        disabled={
          selectIsDisabled || optionsDataFormatted.length === 1 ? true : false
        }
        {...(onChange && { onChange })}
        {...props}
      ></select>
    </div>
  );
};
